import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useCartItems } from "@faire/retailer-visitor-shared/hooks/cart/useCartItems";
import { useState } from "react";
var useCartQuantity = function(productToken) {
    var getProductTileQuantityInCart = useCartItems().getProductTileQuantityInCart;
    return {
        cartQuantity: getProductTileQuantityInCart(productToken)
    };
};
export var useIsNonZeroQuantityPickerValue = function(productToken) {
    var cartQuantity = useCartQuantity(productToken).cartQuantity;
    var _useState = _sliced_to_array(useState(cartQuantity !== 0), 2), isNonZero = _useState[0], setIsNonZero = _useState[1];
    var onQuantityUpdate = function(value) {
        if (value !== undefined) {
            setIsNonZero(value !== 0);
        }
    };
    return {
        isNonZero: isNonZero,
        onQuantityUpdate: onQuantityUpdate
    };
};
